var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4897 36.2468C37.4897 36.9099 37.2264 37.5458 36.7575 38.0146C36.2887 38.4834 35.6528 38.7468 34.9897 38.7468H4.98975C4.3267 38.7468 3.69082 38.4834 3.22198 38.0146C2.75314 37.5458 2.48975 36.9099 2.48975 36.2468V3.74683C2.48975 3.08378 2.75314 2.4479 3.22198 1.97906C3.69082 1.51022 4.3267 1.24683 4.98975 1.24683H29.9897C30.6417 1.24689 31.2679 1.50167 31.7347 1.95683L36.7347 6.76183C36.9737 6.99471 37.1636 7.27307 37.2932 7.58049C37.4229 7.88791 37.4897 8.21818 37.4897 8.55183V36.2468Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8168 11.8083C15.698 10.9464 15.4097 10.1165 14.9685 9.3666C14.7438 8.99389 14.4296 8.68315 14.0545 8.46254C13.6794 8.24194 13.2551 8.11845 12.8202 8.10327C12.2662 8.16292 11.7481 8.40588 11.348 8.79358C10.948 9.18128 10.6888 9.69151 10.6118 10.2433C10.4877 11.3593 10.7764 12.4822 11.4235 13.3999C13.4625 15.7476 15.6539 17.9585 17.9835 20.0183C20.5921 22.1321 23.5437 23.7832 26.7102 24.8999C27.5777 25.3051 28.5262 25.5069 29.4835 25.4899C29.9611 25.4708 30.4209 25.3031 30.7988 25.0104C31.1767 24.7176 31.4539 24.3143 31.5918 23.8566C31.644 23.4803 31.597 23.097 31.4555 22.7444C31.314 22.3919 31.083 22.0824 30.7852 21.8466C30.183 21.382 29.4743 21.0749 28.7235 20.9533C25.7352 20.5167 22.6851 20.8406 19.8552 21.8949C17.1518 22.7283 9.25182 25.3383 9.61516 31.9799C9.62516 32.1466 9.60349 33.2499 11.0268 33.0899C11.6124 32.9757 12.1678 32.741 12.6578 32.4007C13.1479 32.0604 13.5619 31.622 13.8735 31.1133C15.6952 28.5416 15.8852 25.2633 16.1235 22.2283C16.4751 18.7564 16.372 15.2535 15.8168 11.8083V11.8083Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/PdfFile.1a8731d1c8f9a1cf0add0a68577d2b71.svg";
export { ForwardRef as ReactComponent };